import TableCell from '@/components/TableCell';
import Pagination from '@/components/Pagination';
import MultiSelectSearch from '@/components/MultiSelectSearch/MultiSelectSearch';
import sort from '@/utils/Sort';

export default {
  name: 'CustomTable',
  components: {
    TableCell,
    Pagination,
    MultiSelectSearch
  },
  props: {
    data: Array,
    columns: Array,
    actions: {
      type: Array,
      default: function() {
        return [];
      }
    },
    reset: Boolean,
    disabled: {
      type: Array,
      default: function() {
        return [];
      }
    },
    selected: {
      type: Array,
      default: function() {
        return [];
      }
    },
    shouldHighlight: {
      type: Array,
      default: function() {
        return [];
      }
    },
    includeSelectAll: {
      type: Boolean,
      default: false
    },
    select: Function
  },
  data() {
    return {
      currentPage: 1,
      paginationItems: 10,
      sort: {
        order: 'asc',
        column: ''
      }
    };
  },
  computed: {
    paging() {
      const start = (this.currentPage - 1) * this.paginationItems;

      return {
        start: start,
        end: start + this.paginationItems
      };
    },
    sortedData() {
      return sort(this.data, this.sort.column, this.sort.order).slice(
        this.paging.start,
        this.paging.end
      );
    },
    iconDirection() {
      return this.sort.order === 'asc' ? 'sort-up' : 'sort-down';
    },
    allSelected() {
      let hasDisabled = false;
      this.sortedData.map(value => {
        if (this.disabled.includes(value.id)) {
          hasDisabled = true;
        }
      });

      return (
        (this.selected.length === this.sortedData.length ||
          (this.selected.length === this.sortedData.length - 1 &&
            hasDisabled)) &&
        this.sortedData.length
      );
    },
    selectedSimple() {
      return this.selected.map(item => {
        return typeof item === 'object' ? item.id : item;
      });
    }
  },
  mounted() {
    const sortable = this.columns.filter(column => {
      return column.has_sort;
    });

    this.sort.column = sortable[0].key;
  },
  methods: {
    updateCurrentPage(currentPage) {
      this.currentPage = currentPage;
    },
    sortOn(column) {
      if (column === this.sort.column) {
        this.sort.order = this.sort.order === 'asc' ? 'desc' : 'asc';
      } else {
        this.sort.column = column;
        this.sort.order = 'asc';
      }
    },
    isSelected(value) {
      return this.selectedSimple.includes(value.id) ? 'checked' : '';
    },
    selectAll() {
      if (this.allSelected) {
        while (this.selected.length) {
          this.selected.pop();
        }
      } else {
        this.sortedData.map(value => {
          if (
            !this.selected.includes(value) &&
            !this.disabled.includes(value.id)
          ) {
            this.selected.push(value);
          }
        });
      }
    },
    outputColumn(object, key) {
      const value = key.key.split('.');
      var retVal = object;

      while (value.length) {
        var item = value.shift();
        retVal = retVal[item];
      }

      return retVal;
    },
    outputColumnSecondary(object, key) {
      if (key.secondary) {
        const value = key.secondary.split('.');
        var retVal = object;

        while (value.length) {
          var item = value.shift();
          retVal = retVal[item];
        }

        return retVal;
      } else {
        return null;
      }
    }
  }
};
